import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onApply: () => void;
  className?: string;
}

const CTASection = ({ onApply, className = '' }: CTASectionProps) => {
  return (
    <section className={`py-16 lg:py-24 bg-primary text-primary-foreground ${className}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-6">
            Prêt à Commencer Votre Carrière avec Nous?
          </h2>
          <p className="text-lg lg:text-xl mb-8 opacity-90">
            Rejoignez une équipe dynamique où votre travail est valorisé et vos compétences sont développées. Postulez maintenant et commencez votre parcours professionnel avec Rouissi Services.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={onApply}
              className="px-8 py-4 bg-accent text-accent-foreground rounded-lg font-heading font-bold text-lg hover:bg-accent/90 transition-colors duration-300 flex items-center space-x-2"
            >
              <span>Postuler Maintenant</span>
              <Icon name="ArrowRightIcon" size={24} variant="outline" />
            </button>
            <a
              href="/contact"
              className="px-8 py-4 bg-primary-foreground text-primary rounded-lg font-heading font-semibold text-lg hover:bg-primary-foreground/90 transition-colors duration-300 flex items-center space-x-2"
            >
              <Icon name="PhoneIcon" size={24} variant="outline" />
              <span>Nous Appeler</span>
            </a>
          </div>
          <div className="mt-8 pt-8 border-t border-primary-foreground/20">
            <p className="text-sm opacity-80 mb-4">
              Suivez-nous pour rester informé des nouvelles opportunités
            </p>
            <div className="flex justify-center space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Icon name="ShareIcon" size={20} variant="outline" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Icon name="BriefcaseIcon" size={20} variant="outline" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-primary-foreground/10 rounded-full flex items-center justify-center hover:bg-primary-foreground/20 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Icon name="CameraIcon" size={20} variant="outline" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;